import React, { useState } from "react";
import { FaCaretDown, FaCaretUp } from "react-icons/fa";
import "./styles/CustomDropdown.css";
import { useTranslation } from "react-i18next";
import '../localisation/index';

const CustomDropdown = ({ options, keyField, value, setvalue, emptyText }) => {
  const [isActive, setIsActive] = useState(false);
  const {t} = useTranslation()

  return (
    <div className="dropdown">
      <div
        onClick={(e) => {
          setIsActive(!isActive);
        }}
        className="dropdown-btn"
      >
        {/* {validity ? (validity === "180" ? "6 months" : "12 months") : "Select"} */}
        {options.find((item) => Number(item.value) === Number(value))?.title || value ||
          emptyText ||
          "Select"}
        <span>{isActive ? <FaCaretUp /> : <FaCaretDown />}</span>
      </div>
      <div
        className="dropdown-content"
        style={{ display: isActive ? t("commonTexts.block") : t("commonTexts.none") }}
      >
        {options?.map((item, index) => (
          <div
            key={index}
            className="item"
            onClick={(e) => {
              setvalue((prev) => ({ ...prev, [keyField]: item.value }));
              setIsActive(!isActive);
            }}
          >
            {item.title}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomDropdown;
